<div
  class="widget container notifications"
  [ngClass]="{ loadingContainer: loading() }"
  *appHasPermission="{
    permissions: [permissions.allPermissions.NOTIFICATION_READ],
  }"
>
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    <div class="topRow">
      <div class="filters">
        <div class="switch">
          <p-selectButton
            [options]="switchOptions"
            [(ngModel)]="onlyUnread"
            [disabled]="loading() || loadingMore()"
            optionValue="value"
            allowEmpty="false"
            (onChange)="onSwitchChange()"
          >
            <ng-template let-item #item>
              {{ item.label | translate }}
            </ng-template>
          </p-selectButton>
        </div>
        <p-select
          class="categorySelect"
          [options]="categoryOptions"
          [(ngModel)]="selectedCategory"
          [disabled]="loading() || loadingMore()"
          optionValue="value"
          appendTo="body"
          (onChange)="onCategoryChange()"
        >
          <ng-template let-item #item>
            {{ item.label | translate }}
          </ng-template>
          <ng-template let-item #selectedItem>
            {{ item.label | translate }}
          </ng-template>
        </p-select>
      </div>
      <app-button
        *appHasPermission="{
          permissions: [permissions.allPermissions.NOTIFICATION_UPDATE],
        }"
        buttonText="notifications.table.read_all"
        buttonIcon="double_check"
        (click)="readAll()"
      ></app-button>
    </div>
    <p-table
      [columns]="COLUMNS"
      [value]="filteredNotifications()"
      [scrollable]="true"
      scrollHeight="flex"
      [rows]="paginatorOptions.DEFAULT_ROWS"
      [style]="{ flex: 1, 'min-height': 0 }"
      class="notificationsTable tableHeaderAlignTop fullTable"
      [lazy]="true"
      (onLazyLoad)="loadMoreNotifications($event)"
      [lazyLoadOnInit]="false"
      [virtualScroll]="true"
      [virtualScrollItemSize]="71"
      [virtualScrollDelay]="0"
      [virtualScrollOptions]="{ trackBy: trackByNotificationId }"
      [totalRecords]="totalNotificationRecords"
    >
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>
              {{ col.header | translate }}
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr style="height: 60px">
          @for (col of columns; track col) {
            @switch (col.field) {
              @case ("read") {
                @if (rowData && !rowData.notification.readStatus) {
                  <td
                    style="text-align: center"
                    [ngClass]="{
                      pointer: permissions.hasPermission(permissions.allPermissions.NOTIFICATION_UPDATE),
                    }"
                    (click)="readNotification(rowData.notification)"
                    [pTooltip]="translate.instant('notifications.table.mark_as_read')"
                    [tooltipDisabled]="permissions.missesPermission(permissions.allPermissions.NOTIFICATION_UPDATE)"
                    tooltipPosition="bottom"
                  >
                    <div class="readDot"></div>
                  </td>
                } @else {
                  <td></td>
                }
              }
              @case ("createdAt") {
                <td>{{ rowData?.notification.createdAt | date: "dd.MM.yyyy HH:mm" }}</td>
              }
              @case ("notificationCategory") {
                <td>
                  {{ "notifications.notification_templates.categories." + rowData?.notification.category | translate }}
                </td>
              }
              @case ("notificationType") {
                <td>
                  {{ rowData?.titleKey | translate }}
                </td>
              }
              @case ("notificationText") {
                <td>
                  {{ rowData?.textKey | translate: { value: translateParameter(rowData?.value ?? null) } }}
                </td>
              }
              @case ("reference") {
                <td>
                  @if (rowData?.reference?.value) {
                    @if (rowData.reference.additionalValue) {
                      <span class="cursorDefault" [pTooltip]="rowData.reference.additionalValue" tooltipPosition="left">
                        {{ rowData.reference.value }} ...
                      </span>
                    } @else {
                      {{ rowData.reference.value }}
                    }
                  }
                </td>
              }
              @default {
                <td>{{ rowData[col.field] }}</td>
              }
            }
          }
        </tr>
      </ng-template>
    </p-table>
  }
</div>
